import { object, string, ref, boolean } from 'yup';

export const loginValidationSchema = object().shape({
  email: string().email('Email invalide').required('Champ obligatoire'),
  password: string().required('Champ obligatoire'),
});

const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 256;

export const registerValidationSchema = object().shape({
  email: string().email('Email invalide').required('Champ obligatoire'),
  password: string()
    .required('Champ obligatoire')
    .min(MIN_PASSWORD_LENGTH, `Le mot de passe doit faire au minimum ${MIN_PASSWORD_LENGTH} caractères`)
    .max(MAX_PASSWORD_LENGTH, `Le mot de passe doit faire au maximum ${MAX_PASSWORD_LENGTH} caractères`),
  confirmPassword: string()
    .oneOf([ref('password')], 'Les mots de passe doivent correspondre')
    .required('Champ obligatoire'),
  cgu: boolean().oneOf([true], "Vous devez accepter les conditions générales d'utilisation."),
});

export const resetPasswordSchema = object().shape({
  email: string().email('Email invalide').required('Champ obligatoire'),
});
